import { singleValueReducer } from 'store/reducerUtils';
import {
    SET_CONTROLLING_ORG_FILTER,
} from 'modules/settings/submodules/clients/controllingOrg/components/Filter/store/actions';

export const controllingOrgFilter = singleValueReducer(SET_CONTROLLING_ORG_FILTER, '');
